import React, { useEffect, useState } from "react";

import Select from "../../select/select_v2"

import { store } from "react-notifications-component";

import mira from "../../../assets/icons/icon-target-red.png";

import Items from "./items";
import ItemNotFound from "../../../assets/img-undraw-search.svg";

import * as S from "./styles";
import { Auxiliar, BodyM, H6 } from "../../../styles/stylesTypography";
import { theme } from "../../../styles/theme";
import Filter from "../../../assets/icons/icon-Tune.png";
import CardRightV2 from "../../cardRightV2";
import CellWithText from "../../cellWithText";
import api from "../../../services/api";
import identifyErrorMenssage from "../../../services/identifyErrorMenssage";
import PragaDossieDrawer from "../../praga-dossie-drawer";
import { openCulturaUrl } from "../../../utils/culturasPdf";

const CompendioList = ({ isBiologico, produtosOptions, produtos, p, selecionaProduto, loading, total, showFilters, cultura, praga, uf }) => {
  const [width, setWidth] = useState(window.innerWidth);
  const [selectedProduto, setSelectedProduto] = useState(null);
  const [isProdutoCardOpen, setIsProdutoCardOpen] = useState(false);
  const [dossieOpen, setDossieOpen] = useState(false);
  const [dossie, setDossie] = useState({ id: null, name: "" });

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const sendIsShowFilters = () => {
    if (showFilters === true) {
      showFilters(false);
    } else {
      showFilters(true);
    }
  }

  const openProdutoCard = (produto) => {
    getProdutoData(produto.agro_product_id);
  };

  const handleProdutoCardOpenChange = (open) => {
    setIsProdutoCardOpen(open);
    if (!open) setSelectedProduto(null);
  };

  const getProdutoData = async (id) => {
    try {
      const response = await api.get(`compendio/produto/${id}`);

      if(response.status === 200) {
        setSelectedProduto(response.data);
        setIsProdutoCardOpen(true);
      }
    } catch (e) {
       store.addNotification({
          title: "Erro!",
          message: identifyErrorMenssage(
            e,
            "ERRO-567 Erro ao buscar dados do produto - Tente novamente, se o erro persistir acione o suporte."
          ),
          type: "danger",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 5000,
            onScreen: true,
          },
       })
    }
  }

  const buildPragasToDisplay = (pragas = []) => {
    const normalizedNameCount = pragas.reduce((acc, praga) => {
      const commonName = (praga?.nome_comum || "").trim().toLowerCase();
      if (!commonName) return acc;
      acc[commonName] = (acc[commonName] || 0) + 1;
      return acc;
    }, {});

    return pragas.map((praga) => {
      const commonName = (praga?.nome_comum || "").trim();
      const scientificName = (praga?.nome_cientifico || "").trim();
      const normalizedCommonName = commonName.toLowerCase();
      const hasRepeatedCommonName = (normalizedNameCount[normalizedCommonName] || 0) > 1;

      return {
        ...praga,
        displayName: hasRepeatedCommonName && scientificName
          ? `${commonName} - ${scientificName}`
          : commonName,
      };
    });
  };

  const openGoogleImages = (search) => {
    if (!search) return;
    window.open(`https://www.google.com/search?q=${search}&sxsrf=ALiCzsY0y3LwsxgN0oeayW3_AJMzZFXcng:1657226469380&source=lnms&tbm=isch&sa=X&ved=2ahUKEwjV5ZPY0ef4AhWYpZUCHYKmDtAQ_AUoAXoECAIQAw&biw=1536&bih=792&dpr=1.25`, '_blank');
  };

  const getSearchLabel = (commonName, scientificName) => {
    const common = (commonName || "").trim();
    const scientific = (scientificName || "").trim();
    if (scientific && common) return `${scientific} - ${common}`;
    return scientific || common;
  };

  const handlePragaDossie = (praga) => {
    setDossie({ id: praga.id, name: praga.nome_comum || praga.displayName || "" });
    setDossieOpen(true);
  };

  return (
    <S.Container>
      <div style={{ gap: "16px", display: "flex", width: "100%", alignItems: "center", height: "fit-content"}}>

        <Select
          id="produto"
          label="Nome do produto"
          className="select"
          options={produtosOptions}
          value={p}
          onChange={(p) => selecionaProduto(p)}
          isClearable={true}
          loading={loading}
          disabled={loading}
          isCompact={true}
          isSearch={true}
          marginBottom="0"
          height="50px"
        />

        {width < 768 && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "10px",
              cursor: "pointer",
            }}
            onClick={sendIsShowFilters}
          >
            <img style={{ width: "20px" }} src={Filter} alt="Filtros" />
          </div>
        )}
      </div>

      <BodyM fontWeight={700}>
        {!loading && produtos.length > 0
          ? `Foram encontrados ${total} produto${produtos.length !== 1 ? "s" : ""} para seu caso.`
          : null}
      </BodyM>

      {loading ? (
        <S.Loading />
      ) : (
        produtos.length === 0 && (
          <S.ContainerItemNotFound>
            <img src={ItemNotFound} alt="Ícone de pesquisa" />

            <H6 color={theme.colors.gray.Cinza_2}>
              Nenhum produto encontrado para seu caso.
            </H6>
          </S.ContainerItemNotFound>
        )
      )}

      {!loading && (
        <S.List loading={loading}>
          {produtos.map((produto, i) => (
          <Items
            key={`${i}_${produto.id}`}
            isbiologic={produto.isbiologic}
            produto={produto}
            onNameClick={openProdutoCard}
            cultura={cultura}
            praga={praga}
            uf={uf}
          />
          ))}
        </S.List>
      )}

      <CardRightV2
        open={isProdutoCardOpen}
        updateIsOpen={handleProdutoCardOpenChange}
        title={selectedProduto?.nome_comum || ""}
      >
        <S.ContainerModalRight>
          <S.ContainerInfo>
            <BodyM fontWeight={700}>
              Nome comercial:
            </BodyM>

            <Auxiliar>
              {selectedProduto?.nome_comum || ""}
            </Auxiliar>
          </S.ContainerInfo>

          <S.ContainerInfo>
            <BodyM fontWeight={700}>
              Nome técnico:
            </BodyM>

            <Auxiliar>
              {selectedProduto?.nome_tecnico || ""}
            </Auxiliar>
          </S.ContainerInfo>
          
          <S.ContainerInfo>
            <BodyM fontWeight={700}>
              Fabricante:
            </BodyM>

            <Auxiliar>
              {selectedProduto?.fabricante || ""}
            </Auxiliar>
          </S.ContainerInfo>

          <S.ContainerInfo>
            <BodyM fontWeight={700}>
              Classe:
            </BodyM>

            <Auxiliar>
              {selectedProduto?.classes_produto?.map((classe) => classe.nome).join(", ") || ""}
            </Auxiliar>
          </S.ContainerInfo>

          <S.ContainerInfo>
            <BodyM fontWeight={700}>
              Classe toxicológica:
            </BodyM>

            <Auxiliar>
              {selectedProduto?.classe_toxicologica || ""}
            </Auxiliar>
          </S.ContainerInfo>

          <S.ContainerInfo>
            <BodyM fontWeight={700}>
               Bula do produto:
            </BodyM>

            <a href={selectedProduto?.bula} target="_blank" rel="noopener noreferrer">
              <Auxiliar color={theme.colors.blue.Azul_link}>
               Acessar bula
              </Auxiliar>
            </a>
          </S.ContainerInfo>

          <S.ContainerInfo>
            <BodyM fontWeight={700}>
              Restrito em:
            </BodyM>

            <S.ContainerInfoDescription>
              {selectedProduto?.estados_restritos.map((estado) => (
                <CellWithText key={estado} text={estado} />
              ))}
            </S.ContainerInfoDescription>
          </S.ContainerInfo>

          <S.ContainerInfo>
            <BodyM fontWeight={700}>
              Pragas:
            </BodyM>

            <S.ContainerInfoDescription>
              {buildPragasToDisplay(selectedProduto?.pragas).map((praga, index) => (
                <CellWithText
                  key={`${praga.id || praga.nome_comum || "praga"}_${index}`}
                  text={praga.displayName}
                  icon={mira}
                  alt="mira"
                  textColor={theme.colors.red.Vermelho_erro}
                  bgcolor={"#FF525214"}
                  onClick={() => handlePragaDossie(praga)}
                />
              ))}
            </S.ContainerInfoDescription>
          </S.ContainerInfo>

          <S.ContainerInfo>
            <BodyM fontWeight={700}>
              Culturas:
            </BodyM>

            <S.ContainerInfoDescription>
              {selectedProduto?.culturas.map((cultura) => (
                <CellWithText
                  key={cultura.nome_comum}
                  text={cultura.nome_comum}
                  onClick={() => openCulturaUrl(cultura.nome_comum, cultura.nome_cientifico)}
                />
              ))}
            </S.ContainerInfoDescription>
          </S.ContainerInfo>
        </S.ContainerModalRight>
      </CardRightV2>

      <PragaDossieDrawer
        pestId={dossie.id}
        pestName={dossie.name}
        isOpen={dossieOpen}
        onClose={() => setDossieOpen(false)}
      />
    </S.Container>
  );
};

export default CompendioList;
